import intlTelInput from 'intl-tel-input';

const prefixInputClass = 'statePrefix';

export default function initLeadForm() {
  initPhonePrefix()
  initFundForm()
}

function initPhonePrefix() {
  const statePrefixInputs = document.querySelectorAll("." + prefixInputClass)

  if (statePrefixInputs.length > 0) {
    Array.from(statePrefixInputs).forEach((input) => {
      const iti = intlTelInput(input, {
        initialCountry: setInitialCountry(),
        utilsScript: `https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.5.3/js/utils.min.js`,
        preferredCountries: [`cz`, `sk`, `pl`, `gb`, `es`, `hr`, `de`],
      })
      const inputFormId = input.closest('form').id
      input.value = `+${iti.getSelectedCountryData().dialCode}`
      input.addEventListener("countrychange", () => {
        input.value = `+${iti.getSelectedCountryData().dialCode}`
        document.getElementById(inputFormId + "-phone").focus()
      })
      input.addEventListener("click", (e) => {
        document.getElementById(inputFormId + "-phone").focus()
      })
      input.addEventListener("focus", (e) => {
        document.getElementById(inputFormId + "-phone").focus()
      })
    })
  }
}

function initFundForm() {
  // Keep body scrolled on the right position when form is open (not scroll to top)
  const fundForm = document.querySelector('#fund-form');
  if (fundForm) {
    const fundBtns = document.querySelectorAll('.fund-form-cta');
    const fundCloseBtns = document.querySelectorAll('.fund-form__close');
    let scrollPosition = 0;

    fundBtns.forEach(fundBtn => {
      fundBtn.addEventListener('click', () => {
        // Open the menu
        scrollPosition = window.scrollY;
        fundForm.classList.add('fund-form--open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = '100%';
      });

    });

    fundCloseBtns.forEach(fundCloseBtn => {
      fundCloseBtn.addEventListener('click', () => {
        if (fundForm.classList.contains('fund-form--open')) {
          // Close the menu
          fundForm.classList.remove('fund-form--open');
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';

          // Temporarily disable smooth scrolling
          document.documentElement.style.scrollBehavior = 'auto';
          window.scrollTo(0, scrollPosition);
          // Re-enable smooth scrolling
          document.documentElement.style.scrollBehavior = '';
        }
      });
    });
  }
}

function setInitialCountry() {
  const locale = document.documentElement.getAttribute("lang")
  switch (locale) {
    case "cs":
      return "cz"
    case "en":
      return "gb"
    case "pl":
      return "pl"
    case "sk":
      return "sk"
    case "hr":
      return "hr"
    case "es":
      return "es"
    default:
      return "cz"
  }
}